import validator, { PhoneLocale } from "validator";

export const required =
  (subject: string, customMessage?: string) => (v: any) => {
    if (!!v) {
      return true;
    } else {
      return customMessage || `${subject} is required`;
    }
  };

export const isMobilePhone =
  (locale: PhoneLocale = "en-US") =>
  (v: any) => {
    const parsedValue =
      locale === "en-AU" ? "61" + v.replaceAll(" ", "").replace(/^0+/, "") : v;

    return (
      validator.isMobilePhone(parsedValue, locale) ||
      "Valid mobile phone number is required"
    );
  };

export const isEmail = (errorMessage?: string) => (v: any) =>
  validator.isEmail(v) || errorMessage || "Valid email is required";

export const minAmount = (min: number, currencySymbol: string) => (v: any) => {
  const cleanedV = v.toString().match(/\d+/g)?.[0];
  if (parseInt(cleanedV) >= min) {
    return true;
  } else {
    return ``;
  }
};

export const maxAmount = (max: number, currencySymbol: string) => (v: any) => {
  const cleanedV = v.toString().match(/\d+/g)?.[0];
  if (parseInt(cleanedV) <= max) {
    return true;
  } else {
    return ``;
  }
};
